exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-57558f72] .el-dialog__footer{padding:20px 0}[data-v-57558f72] .el-select{width:100%}.dialog-footer[data-v-57558f72]{padding-top:20px;border-top:1px solid #e6ebf5}\n", ""]);

// exports
